import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import type { RootState } from "@/store/store";
import { type Document, fetchDocumentsThunk } from "./documentOperations";

// Redux Toolkit v2: selectId is no longer needed if entities have an 'id' field
const entityAdapter = createEntityAdapter<Document>();

type DocumentsState = ReturnType<typeof entityAdapter.getInitialState> & {
  textSearch: string;
  isLoading: boolean;
};

const initialState: DocumentsState = {
  textSearch: "",
  isLoading: false,
  ...entityAdapter.getInitialState(),
};

const slice = createSlice({
  name: "documents",
  initialState,
  reducers: {
    setTextSearch(state, action) {
      state.textSearch = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchDocumentsThunk.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchDocumentsThunk.fulfilled, (state, action) => {
      entityAdapter.setAll(state, action.payload);
      state.isLoading = false;
    });
    builder.addCase(fetchDocumentsThunk.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

const selectSelf = (state: RootState) => state.documents.documents;

export const documentSelectors = {
  selectTextSearch: (state: RootState) => selectSelf(state).textSearch,
  ...entityAdapter.getSelectors(
    (state: RootState) => state.documents.documents,
  ),
};

export const documentActions = slice.actions;

export const reducer = slice.reducer;
